import React, {ReactNode, ComponentProps} from 'react';
import classNames from 'classnames';
import Fieldset from './fieldset';
import RadioButton, {Props as RadioButtonProps} from 'src/components/radio-button';

export interface Props extends Pick<ComponentProps<'input'>, 'name' | 'onChange' | 'onBlur'> {
  value?: string;
  options: RadioButtonProps[];
  error?: string;
  legendText?: ReactNode;
  required?: boolean;
  className?: string;
}

const RadioButtons = ({
  name,
  value,
  onChange,
  onBlur,
  options,
  legendText,
  required,
  error,
  className,
}: Props) => (
  <Fieldset className={classNames(className, {'mt-0': !legendText})}>
    {legendText && <Fieldset.Legend required={required}>{legendText}</Fieldset.Legend>}
    {options.map(({value: optionValue, label, disabled, ...optionProps}, i) => (
      <RadioButton
        key={`${name}-${i}`}
        value={optionValue}
        label={label}
        // We have some areas pre-TS where value is a boolean so we're
        // making everything a string before doing the comparison
        checked={`${value}` === `${optionValue}`}
        name={name}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        error={!!error}
        {...optionProps}
      />
    ))}
    {error && (
      <p className="shared-error-text" role="alert">
        {error}
      </p>
    )}
  </Fieldset>
);

export default RadioButtons;
